"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const ContactTracingApi_1 = __importDefault(require("../../api/ContactTracingApi"));
const mobx_react_1 = require("mobx-react");
const ContactView_1 = __importDefault(require("./ContactView"));
const ContactsViewComponent = ({ caseData, holds, searchUser }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isError, setError] = (0, react_1.useState)(false);
    const [contacts, setContacts] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        fetchContacts();
    }, []);
    const fetchContacts = () => {
        setLoading(true);
        ContactTracingApi_1.default.fetchContact(caseData.case_guid).then((response) => {
            if (response.error) {
                setLoading(false);
            }
            else {
                setLoading(false);
                if (response.items) {
                    setContacts(response.items);
                }
            }
        });
    };
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "case-row" }, { children: [isLoading && (0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] }), !isLoading && contacts.length === 0 && (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "No contacts available", type: hui_1.ErrorType.NoData }), !isLoading &&
                    contacts.length > 0 &&
                    contacts.map((itm) => {
                        return (0, jsx_runtime_1.jsx)(ContactView_1.default, { caseData: caseData, contactData: itm, fetchContacts: () => fetchContacts() });
                    })] })) }));
};
const ContactsView = (0, mobx_react_1.inject)("covidNav", "holds", "searchUser")((0, mobx_react_1.observer)(ContactsViewComponent));
exports.default = ContactsView;
